import React from 'react';
import { legalInfo } from '../utils/legal';
import { Link } from 'react-router-dom';

const CookiePolicy: React.FC = () => {
  return (
    <div className="max-w-3xl mx-auto px-4 py-8 text-left">
      <h1 className="text-3xl font-bold mb-4">Cookie Policy</h1>
      <p className="text-gray-700 mb-6">Last updated: {new Date().getFullYear()}</p>

      <p className="mb-4">This policy explains how {legalInfo.tradingName || legalInfo.legalName} uses cookies and similar technologies.</p>

      <h2 className="text-xl font-semibold mt-6 mb-2">What are cookies?</h2>
      <p className="mb-4">Cookies are small files placed on your device to make the site work and to remember your preferences.</p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Types we use</h2>
      <ul className="list-disc ml-6 space-y-2">
        <li>Strictly necessary: required for core functionality (cannot be turned off).</li>
        <li>Preferences: remember your settings.</li>
        <li>Analytics: help us improve the site.</li>
        <li>Marketing: personalize offers and measure campaigns.</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">Managing consent</h2>
      <p className="mb-4">You can manage your cookie preferences at any time in our <Link to="/cookie-settings" className="text-red-500 underline">Cookie Settings</Link>.</p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Third parties</h2>
      <p className="mb-4">If we use third-party services (e.g. analytics, payment), they may set cookies as described in their policies.</p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Contact</h2>
      <p>Questions? Email {legalInfo.dataProtectionEmail || legalInfo.publicEmail || 'add email'}.</p>
    </div>
  );
};

export default CookiePolicy;





